import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const ClockIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}
            <path
                d="M16.5 6C10.7104 6 6 10.7102 6 16.5C6 22.2898 10.7104 27 16.5 27C22.2898 27 27 22.2898 27 16.5C27 10.7102 22.2896 6 16.5 6ZM16.5 25.4672C11.5556 25.4672 7.53284 21.4444 7.53284 16.5C7.53284 11.5556 11.5556 7.53284 16.5 7.53284C21.4444 7.53284 25.4672 11.5555 25.4672 16.4998C25.4672 21.4444 21.4444 25.4672 16.5 25.4672Z"
                fill={"currentColor"}
            />
            <path
                d="M20.0767 16.4997H16.7555V11.9012C16.7555 11.4779 16.4124 11.1348 15.9891 11.1348C15.5658 11.1348 15.2227 11.4779 15.2227 11.9012V17.2662C15.2227 17.6895 15.5658 18.0326 15.9891 18.0326H20.0767C20.5 18.0326 20.8431 17.6895 20.8431 17.2662C20.8431 16.8428 20.5 16.4997 20.0767 16.4997Z"
                fill={"currentColor"}
            />
        </svg>
    );
};

export default ClockIcon;
